export function lastModifiedOf(file) {
	if (!file || typeof file.lastModified !== "number") return undefined;
	return new Date(file.lastModified);
}
